import { Impermissible } from './Impermissible';
export default Impermissible;
